export const links = [
  {
    id: 1,
    name: 'ABOUT',
    url: '/about',
    textMain: "A Full Stack Developer with a background in Mechanical Engineering. I have recently graduated from Lighthouse Labs' Full Stack Development Bootcamp and I am currently seeking an entry-level developer position. I strongly gravitate towards designing and developing applications that have a notable impact on large amounts of people, solve real problems, and have memorable user experiences. I have an entrepreneurial spirit and enjoy leadership positions which I fully embrace through my side-hustle, HiOctave - a web design, and digital marketing agency that I started to further enhance my tech skills.",
    textSubMain: "HiOctave allows me to explore my creativity in the areas of front-end development, UI design, photography, and videography, which in turn has immensely enhanced my creativity as both a programmer and a person.",
    textInspo: "The design of this website was inspired by Spotify. I have always admired Spotify's UI/UX design, and most of the time when I am programming, I am using the platform. Music plays a huge role in my life as a developer, and with Spotify being such an inspiring tech company, this design seemed very fitting.",
    textSub: "When I'm not at my computer, you can find me skiing, mountain biking, reading, or taking photos of the outdoors and/or food."
  },
  {
    id: 2,
    name: 'SKILLS',
    url: '/skills',
    textMain: '',
    textInspo: '',
    textSub: ''
  },
  // {
  //   id: 3,
  //   name: 'CONTACT',
  //   url: '/contact',
  //   textMain: '',
  //   textSub: ''
  // },
]